import { Typography } from '@/components/ui/typography';
import { FloorPlanTierImage } from './FloorPlanTierImage';

interface FloorPlanServiceLineProps {
  name: string;
  /** The service's catalog image (DV-3808); without one, the bundled Basic example. */
  onlineImage: string | null;
}

/**
 * The free Basic Floor Plan as a line under a property's services: in the cart
 * before the order exists (the line is added by order-service at creation, so
 * the cart only shows it), and on order confirmation as the line itself. It
 * carries no price or count: it is not a photo service, and the slider's tier
 * card is where it reads as free.
 */
export function FloorPlanServiceLine({
  name,
  onlineImage
}: FloorPlanServiceLineProps) {
  return (
    <div
      className="flex items-center gap-3"
      data-testid="floor-plan-service-line"
    >
      <FloorPlanTierImage
        tierId="basic"
        onlineImage={onlineImage}
        height={64}
        width={98}
        className="h-16 w-[98px] shrink-0 rounded-md bg-muted object-contain p-1"
      />
      <Typography variant="body" className="flex-1">
        {name}
      </Typography>
    </div>
  );
}
